(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-audio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(s) {
      var m = Math.floor(s / 60);
      var sec = Math.floor(s % 60);
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    function stopAll(except) {
      document.querySelectorAll('.bap').forEach(function (el) {
        if (el === except) return;
        var a = el.querySelector('audio');
        if (!a.paused) a.pause();
        el.classList.remove('bap--playing');
      });
    }

    function initPlayer(el) {
      var src = el.dataset.audioSrc;
      var audio = el.querySelector('audio');
      var playBtn = el.querySelector('.bap__play-btn');
      var fill = el.querySelector('.bap__progress-fill');
      var scrubber = el.querySelector('.bap__progress-scrubber');
      var progress = el.querySelector('.bap__progress');
      var timeCurrent = el.querySelector('.bap__time-current');
      var timeDuration = el.querySelector('.bap__time-duration');
      var loaded = false;

      function load() {
        if (loaded || !src) return;
        loaded = true;
        audio.src = src;
        audio.load();
      }

      audio.addEventListener('loadedmetadata', function () {
        timeDuration.textContent = fmt(audio.duration);
      });

      audio.addEventListener('timeupdate', function () {
        if (!audio.duration) return;
        var pct = (audio.currentTime / audio.duration) * 100;
        fill.style.width = pct + '%';
        scrubber.style.left = pct + '%';
        timeCurrent.textContent = fmt(audio.currentTime);
      });

      audio.addEventListener('ended', function () {
        el.classList.remove('bap--playing');
        fill.style.width = '0%';
        scrubber.style.left = '0%';
        timeCurrent.textContent = '0:00';
        audio.currentTime = 0;
      });

      playBtn.addEventListener('click', function () {
        load();
        if (audio.paused) {
          stopAll(el);
          audio.play();
          el.classList.add('bap--playing');
        } else {
          audio.pause();
          el.classList.remove('bap--playing');
        }
      });

      progress.addEventListener('click', function (e) {
        load();
        if (!audio.duration) return;
        var rect = progress.getBoundingClientRect();
        var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        audio.currentTime = pct * audio.duration;
      });
    }

    document.querySelectorAll('.bap').forEach(initPlayer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
